import React from 'react'
import { Link } from "react-router-dom"
import social_icons from '../Data/social_icons'

const Contact = () => {
    const mapStyle = {
        border: "0"
    }

    // function to stop PHP form submission
    const handleForm = (event) => {
    event.preventDefault()
  }

  return (
    <>
        <section className='contact'>
            <div className="container contact-container">
                <h3 className="section-subtitle">AutoInsure</h3>
                <h1 className="section-title">Contact Us</h1>
                <div className="contact-box">
                    <div className="contact-top-container">
                        <div className="contact-details">
                            <h4 className="contact-title">Contact Information</h4>
                            <address className="contact-address">
                                17 Britten Street <br/>
                                London <br/>
                                United Kingdom <br/>
                                SW3 3TX
                            </address>
                            <p className="contact-email">Email: <span className="contact-email-link">autoinsure@gmail.com</span></p>
                            <p className="contact-phone">Phone: <span className="contact-phone-link">+44 2079 998999</span></p>
                            <h4 className="follow-us">Follow Us:</h4>
                            <div className="contact-icon-container">
                                {social_icons.map((i) => {
                                    return (
                                        <div key={i.id} id={i.id} className="contact-icon-capsule">
                                            <Link to={i.link}>
                                                {i.icon}
                                            </Link>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        <div className="contact-map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4968.6186377580725!2d-0.168181!3d51.489191!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876056b8fb6485b%3A0x4c9655e8fdcbd65!2s17%20Britten%20St%2C%20London%20SW3%203TX!5e0!3m2!1sen!2suk!4v1686132483850!5m2!1sen!2suk" width="100%" height="300px" style={mapStyle} allowfullscreen="" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                    <div className="contact-bottom-container">
                        <h2 className="contact-form-title">Get In Touch With Us</h2>
                        <p className="contact-form-subtitle">Fill in the form below to send us a message about a query, job opportunities or to rent a car!</p>
                        <form onSubmit={handleForm} className="contact-form">
                            <div className="contact-form-group">
                                <input type="text" name="first-name" id="first-name" className='first-name' placeholder='First Name...'/>
                            </div>
                            <div className="contact-form-group">
                                <input type="text" name="last-name" id="last-name" className='last-name' placeholder='Last Name...'/>
                            </div>
                                <textarea name="contact-message" id="contact-message" className='contact-message' cols="30" rows="10" placeholder='Type your message here...'/>
                            <button className="btn btn-lg contact-submit-btn">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    </>
  )
}

export default Contact
